import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get } from '~/actions/actions';
import Title from '~/components/Title';
import Tag from '~/components/Tag';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    return get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderFromTo(item) {
    return (
      <div>
        <div>Take containers from: <Tag type="location" id={item.data.locationFrom} /></div>
        <div>Move to when done: <Tag type="location" id={item.data.locationTo} /></div>
      </div>
    );
  }

  renderPick(item) {
    return (
      <div>
        <div>Take containers from: <Tag type="location" id={item.data.locationFrom} /></div>
        <div>Move to when done: <Tag type="location" id={item.data.locationTo} /></div>
        <div>Take articles from: <Tag type="location" id={item.data.locationPick} /></div>
      </div>
    );
  }

  renderEmpty(item) {
    return (
      <div>
        <div>Take containers from: <Tag type="location" id={item.data.locationFrom} /></div>
        <div>Move to: <Tag type="location" id={item.data.locationTo} /></div>
        <div>And empty the contents of the containers</div>
      </div>
    );
  }

  renderVerify(item) {
    return (
      <div>
        <div>Take containers from: <Tag type="location" id={item.data.locationFrom} /></div>
        <div>Move to when correct: <Tag type="location" id={item.data.locationSuccess} /></div>
        <div>Move to when not correct: <Tag type="location" id={item.data.locationFail} /></div>
        <div>Warehouse location: <Tag type="location" id={item.data.locationDiff} /></div>
      </div>
    );
  }

  renderOrderPick(item) {
    return (
      <div>
        <div>Take containers from: <Tag type="location" id={item.data.locationFrom} /></div>
        <div>Move finished containers to: <Tag type="location" id={item.data.locationTo} /></div>
        <div>Take articles from: <Tag type="location" id={item.data.locationPick} /></div>
      </div>
    );
  }

  renderType(item) {
    if (item.type === 'container_pick') { return this.renderPick(item); }
    if (item.type === 'container_verify') { return this.renderVerify(item); }
    if (item.type === 'container_move') { return this.renderFromTo(item); }
    if (item.type === 'container_empty') { return this.renderEmpty(item); }
    if (item.type === 'container_shipping_set') { return this.renderFromTo(item); }
    if (item.type === 'order_pick') { return this.renderOrderPick(item); }
    return <pre style={{ fontSize: '10px' }}>{JSON.stringify(item.data, undefined, 4)}</pre>;
  }

  renderDialog() {
    const { item } = this.props;
    const userIds = item.userIds || [];
    const allUsersPermitted = !item.userIds || userIds.includes('all');
    return (
      <div>
        <Button
          style={{ float: 'right' }} label="Edit details" className={style.buttonEdit}
          onClick={() => this.context.dialogPush('actionNew', { id: item.id })}
        />
        <Title style={{ marginBottom: '10px' }}>Action Information</Title>
        <div>Action #{item.sku}</div>
        <div>Name: {item.name}</div>
        {this.renderType(item)}
        <div>
          Permitted users: {allUsersPermitted && 'All users permitted'}
          {!allUsersPermitted && userIds.map(userId => userId !== 'all' ? <Tag type="user" id={userId} /> : null)}
        </div>
        {item.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.state.loading && 'Loading'}
            {!this.state.loading && !this.props.item && '404'}
            {!this.state.loading && this.props.item && this.renderDialog()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  item: state.getIn(['actions', 'items', props.data.id]) && state.getIn(['actions', 'items', props.data.id]).toJS(),
});

export default connect(mapStateToProps)(Dialog);




// WEBPACK FOOTER //
// ./app/dialogs/Action/index.js